// === GENERATED FILE ===
// DO NOT EDIT DIRECTLY, EDIT sh-radio-group.lit.scss INSTEAD!
import { css } from 'lit-element';
export default css`:root,
[sh-scale=s] {
  /* 
   * @cssprop [--sh-radio-group-margin=0] - margin for the radio-button
   */
  --sh-radio-group-margin: 0;
}

:host {
  width: 100%;
  outline: 0;
  display: block;
}

.radio-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}

#grouped {
  flex: 1;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.radio-wrapper > ::slotted(*) {
  margin-top: var(--sh-radio-group-margin);
}

.radio-wrapper > ::slotted(:first-child) {
  margin-top: 0;
}`;